import React from 'react';
import MediaSelectContext from 'app/app/mediaSelector/contexts/MediaSelectContext';

function MediaSelectProvider(props) {
    const [selectedMedia, setSelectedMedia] = React.useState([]);

    const addMedia = (media) => setSelectedMedia([...selectedMedia, media]);

    const removeMedia = (id) => setSelectedMedia(selectedMedia.filter(media => media.ID !== id));

    const handleSelectMedia = (media) => {
        if(!media) return;

        if (selectedMedia.includes(media)) {
            return removeMedia(media.id);
        }

        return addMedia(media);
    }

    const resetSelectedMedia = () => {
        let media = [];
        return setSelectedMedia(media);
    }


    return (
        <MediaSelectContext.Provider value={{selectedMedia, handleSelectMedia, resetSelectedMedia}}>
            {props.children}
        </MediaSelectContext.Provider>
    );
}

export default MediaSelectProvider;
